import React, { useState } from 'react';
import { FadeIn } from './ui/FadeIn';
import { ChevronDown } from 'lucide-react';
interface FAQItem {
  question: string;
  answer: string;
}
const faqs: FAQItem[] = [{
  question: '¿Es un producto físico?',
  answer: 'No. Es un producto 100% digital que recibís de forma inmediata.'
}, {
  question: '¿Cómo lo recibo?',
  answer: 'Una vez realizada la compra, obtenés acceso al material de forma inmediata para descargar.'
}, {
  question: '¿Para quién está pensado?',
  answer: 'Para padres, madres, maestros, líderes infantiles y familias cristianas que desean enseñar valores bíblicos.'
}, {
  question: '¿Dónde se puede usar?',
  answer: 'En casa, en la iglesia, en escuela dominical o en el aula. Se adapta a cualquier espacio.'
}, {
  question: '¿Es fácil de aplicar?',
  answer: 'Sí. Todo el material fue pensado para que sea claro, simple y práctico, sin necesidad de preparación previa.'
}, {
  question: '¿Puedo usarlo en iglesia o clases infantiles?',
  answer: 'Por supuesto. Los recursos están diseñados para funcionar tanto en el hogar como en contextos educativos y eclesiales.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-8" style={{
    backgroundColor: 'var(--color-off-white)'
  }} data-id="element-57">
      <div className="container mx-auto px-4" data-id="element-58">
        <div className="max-w-2xl mx-auto" data-id="element-59">
          <FadeIn data-id="element-60">
            <h2 className="text-2xl md:text-3xl font-bold text-center mb-6" style={{
            color: 'var(--color-deep-blue)'
          }} data-id="element-61">
              Preguntas frecuentes
            </h2>
          </FadeIn>

          <div className="space-y-2.5" data-id="element-62">
            {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.05} data-id="element-63">
                <div className="bg-white rounded-xl border overflow-hidden transition-shadow duration-200" style={{
              borderColor: openIndex === index ? 'var(--color-sky-mid)' : 'var(--color-border)',
              boxShadow: openIndex === index ? '0 2px 8px rgba(30,58,95,0.06)' : '0 1px 2px rgba(0,0,0,0.04)'
            }} data-id="element-64">
                  <button className="w-full px-5 py-4 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} aria-expanded={openIndex === index} data-id="element-65">
                    <span className="text-base font-bold pr-3" style={{
                  color: 'var(--color-deep-blue)'
                }} data-id="element-66">
                      {faq.question}
                    </span>
                    <ChevronDown className="w-5 h-5 flex-shrink-0 transition-transform duration-300" style={{
                  color: openIndex === index ? 'var(--color-gold)' : 'var(--color-body)',
                  transform: openIndex === index ? 'rotate(180deg)' : 'rotate(0deg)'
                }} data-id="element-67" />
                  </button>
                  <div className="overflow-hidden transition-all duration-300 ease-in-out" style={{
                maxHeight: openIndex === index ? '150px' : '0px',
                opacity: openIndex === index ? 1 : 0
              }} data-id="element-68">
                    <p className="px-5 pb-4 text-base leading-relaxed" style={{
                  color: 'var(--color-body)'
                }} data-id="element-69">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              </FadeIn>)}
          </div>
        </div>
      </div>
    </section>;
}